import { Link } from "react-router-dom";
import { Facebook, Instagram, Phone, Mail } from "lucide-react";
import { SITE } from "../data/site";
import { useLang } from "../context/LanguageContext";

export function Footer() {
  const { t } = useLang();
  return (
    <footer className="relative bg-brand-gray text-white pt-16 pb-10 mt-0 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <img src={SITE.logo} alt="Nica Moto Rentals" className="h-14 w-auto bg-white rounded-lg p-1.5 mb-4" />
          <p className="text-white/70 max-w-sm leading-relaxed">{t.footer.blurb}</p>
          <p className="text-brand-sky font-heading font-bold mt-4" data-testid="footer-serving-tagline">{t.footer.serving}</p>
          <div className="flex gap-3 mt-5">
            <a href={SITE.facebook} target="_blank" rel="noreferrer" className="bg-white/10 hover:bg-brand-orange transition-colors p-2.5 rounded-full" data-testid="footer-facebook">
              <Facebook size={18} />
            </a>
            <a href={SITE.instagram} target="_blank" rel="noreferrer" className="bg-white/10 hover:bg-brand-orange transition-colors p-2.5 rounded-full" data-testid="footer-instagram">
              <Instagram size={18} />
            </a>
          </div>
        </div>

        <div>
          <h4 className="font-heading font-bold text-sm uppercase tracking-widest text-brand-sky mb-4">{t.footer.explore}</h4>
          <ul className="space-y-2 text-white/80">
            <li><Link to="/motorcycles" className="hover:text-brand-orange">{t.nav.motorcycles}</Link></li>
            <li><Link to="/services/car-wash" className="hover:text-brand-orange">{t.nav.carwash}</Link></li>
            <li><Link to="/services/maintenance" className="hover:text-brand-orange">{t.nav.maintenance}</Link></li>
            <li><a href={SITE.googleBusiness} target="_blank" rel="noreferrer" className="hover:text-brand-orange">{t.footer.googleReviews}</a></li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading font-bold text-sm uppercase tracking-widest text-brand-sky mb-4">{t.footer.contact}</h4>
          <ul className="space-y-3 text-white/80">
            <li className="flex items-center gap-2"><Phone size={18} className="text-brand-orange" /> <a href="tel:+50586816386">+505 8681 6386</a></li>
            <li className="flex items-center gap-2"><Phone size={18} className="text-brand-orange" /> <a href="tel:+50587885920">+505 8788 5920</a></li>
            <li className="flex items-center gap-2"><Mail size={18} className="text-brand-orange" /> <a href={`mailto:${SITE.email}`}>{SITE.email}</a></li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-12 pt-6 border-t border-white/10 text-white/50 text-sm flex flex-col sm:flex-row justify-between gap-2">
        <span>© {new Date().getFullYear()} Nica Moto Rentals. {t.footer.rights}</span>
        <Link to="/login" className="hover:text-brand-sky" data-testid="footer-admin-link">{t.footer.admin}</Link>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-3 text-center text-white/40 text-xs" data-testid="footer-credit">
        Website created by{" "}
        <a href="https://www.GregMiceli.com" target="_blank" rel="noreferrer" className="hover:text-brand-sky underline underline-offset-2">www.GregMiceli.com</a>
      </div>
    </footer>
  );
}

export default Footer;
